import {
    Button,
    Grid,
    Typography
}                      from "@mui/material";
import {
    useEffect,
    useRef
}                      from "react";
import {
    Contact,
    DeactivateContactCommand,
    DeactivatePoolCommand,
    Delete,
    IGStyle,
    Pool,
    PoolDetail,
    UpdatePool
} from "../../constants";
import {useZINContext} from "../../context/ZinContextProvider";
import {submitObject}  from "../../util";

const ZwembadInrichtingBlock = () =>
{
    const {
        poolDetails,
        refreshResource,
        setRefreshResource,
        setFormData,
        setModalVisible,
        setModalAction,
        setActivePage,
        setAlertVisible, setAlertText,
        setDeleteCallback
    } = useZINContext()

    const RDRef = useRef<any>()

    useEffect(() =>
    {
        switch (refreshResource)
        {
            case PoolDetail:
                setTimeout(() => RDRef.current?.refresh(), 1000)
                break
        }
        setRefreshResource("")
    }, [refreshResource]);

    function ZwembadinrichtingBewerken()
    {
        setFormData(RDRef.current?.data)

        setModalVisible(true)
        setModalAction(UpdatePool)
    }

    const handleStartDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
        setModalVisible(true)
        setModalAction(Delete)
        setDeleteCallback({delete: DeleteObject} )
    };
    function DeleteObject() {
        submitObject({id: poolDetails?.id}, poolDetails?.id, DeactivatePoolCommand).then(async (event: any) =>
        {
            HandleSubmit(event)
        })

        setActivePage(0)
        setRefreshResource(Pool)
    }
    async function HandleSubmit(event: any)
    {
        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status !== 200){
            const response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }
    }


    return (<>
        <Grid container justifyContent="center" direction={"column"}>
            <Grid container className={"rm-container"} direction={"row"}>
                <Grid container>
                    <Typography variant="h4" marginRight={"auto"}>
                        Zwembadinrichting
                    </Typography>
                </Grid>

                <Grid item xs={8} container alignItems={"stretch"} className={"containerspacing"}>
                    {/*// @ts-ignore*/}
                    <ig-resource-detail class={"od-table-resource ig-detail-remove-id"} lang="nl-NL" ref={RDRef} style={IGStyle} resource-detail-id="PoolRD" resource-id={poolDetails?.id}/>
                </Grid>

                <Grid container item className={"button-container"} xs={3} marginLeft={1} justifyContent={"flex-start"}>

                    <Grid item xs={4}>
                        <Grid container direction="column" item>
                            <Button className={"od-button"} variant={"contained"} onClick={ZwembadinrichtingBewerken}>Badinrichting Bewerken</Button>
                            <Button className={"od-button"} variant={"contained"} onClick={handleStartDelete}>Badinrichting Deactiveren</Button>
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    </>)
}

export default ZwembadInrichtingBlock